import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Dropdown1 from '../Dropdown1'
import Icon from 'srcReact/components/icons/Icon'
import { useDispatch, useSelector } from 'react-redux'
import { rsvpActions } from './actions'
import Button from '../Button'
import Modal from '../Modal'
import PendingJoinGroupApproval from 'srcReact/components/popinsContent/PendingJoinGroupApproval'
import ConfirmModal from '../ConfirmModal'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import history from 'srcReact/helpers/history'

export default function RSVP({
  mixrId,
  mixrAttendingType,
  selectedUserAttending,
  groupRole,
  groupName,
  withoutGroupAproval,
  className,
  menuPortalTarget = false,
  isStatic = false,
  isInvite = false,
  isRecurrence,
  recurrenceMixrAttending = 'none'
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedItem, setSelectedItem] = useState(null)
  const [showJoinGroupPopup, setShowJoinGroupPopup] = useState(false)
  const [showPendingApprovalPopup, setShowPendingApprovalPopup] = useState(false)
  const [joinGroupForMixrId, setJoinGroupForMixrId] = useState(0)
  const [showAutoJoinGroupWarning, setShowAutoJoinGroupWarning] = useState(false)
  const [isRSVPChanged, setIsRSVPChanged] = useState(false)
  const [isRecAllModalOpen, setIsRecAllModalOpen] = useState(false)

  const {
    common: { bannerData },
    rsvp: { loading: rsvpLoading, success: rsvpSuccess, error: rsvpError, data: rsvpData },
    integration: { activeIntegrations, triggerAddToCalendar }
  } = useSelector((state) => state)

  //This useeffect will be called when user changes RSVP to in_person or virtual
  //Earlier this code was in Banner component, which had a button "Add to Calendar"
  useEffect(() => {
    const location = history.location.pathname
    if (!location.match(/create-mixr/) && !location.match(/edit-mixr/) && triggerAddToCalendar && isRSVPChanged) {
      setIsRSVPChanged(false)
      const defaultCalendar = activeIntegrations?.list?.find((x) => x.is_default === 1 && x.usage === 'add_to_calendar')
      const banner = bannerData.find((b) => b.mixrId > 0)
      const recurUpdate = selectedItem.recur === 'none' ? 'unique' : 'all'
      if (banner && defaultCalendar) {
        dispatch(
          integrationActions.postEventToCalendar(
            banner.mixrId,
            defaultCalendar.external_api,
            defaultCalendar.id_external_api_auth,
            recurUpdate
          )
        )
      } else if (banner?.mixrId) {
        dispatch(integrationActions.openCalendarModal(banner.mixrId, recurUpdate))
      }
    }
    return () => {
      if (triggerAddToCalendar) {
        dispatch(integrationActions.clearData())
      }
    }
  }, [triggerAddToCalendar])

  useEffect(() => {
    if (!rsvpLoading && rsvpSuccess && rsvpData) {
      if (rsvpData.attending === 'pending_participant' || rsvpData.attending === 'can_t_go') {
        setIsRSVPChanged(false)
        if (rsvpData.attending === 'pending_participant') {
          setShowJoinGroupPopup(false)
          setShowPendingApprovalPopup(true)
          setJoinGroupForMixrId(0)
        }
      } else if (rsvpData.attending === 'in_person' || rsvpData.attending === 'virtual') {
        //Once RSVP is succeeded, call add to calendar logic directly from RSVP.
        //Earlier this code was in Banner component, which had a button "Add to Calendar"
        const organizationId = getCurrentOrgId()
        dispatch(integrationActions.getActiveIntegrations(organizationId, 'add_to_calendar'))
      }
      closeAutoJoinGroupPopup()
    }
  }, [rsvpLoading, rsvpSuccess])

  const getRsvpDropdownOptions = () => {
    const items = []

    if (mixrAttendingType === 'in_person') {
      items.push({
        value: 'in_person',
        label: t('mixrHome.feeds.going'),
        recur: 'none'
      })
    }
    if (mixrAttendingType === 'virtual') {
      items.push({
        value: 'virtual',
        label: t('mixrHome.feeds.going'),
        recur: 'none'
      })
    }
    if (mixrAttendingType === 'both') {
      items.push({
        value: 'in_person',
        label: t('mixrHome.feeds.inPersonGoing'),
        recur: 'none'
      })
      items.push({
        value: 'virtual',
        label: t('mixrHome.feeds.virtualGoing'),
        recur: 'none'
      })
    }
    if (isRecurrence) {
      items.push({
        value: `${mixrAttendingType}__all`,
        label: t('mixrHome.feeds.goingAll'),
        recur: 'all'
      })
    }
    items.push({
      value: 'can_t_go',
      label: t('mixrHome.feeds.notGoing')
    })

    return items
  }

  const textSize = () => {
    let size = 'large'
    if (selectedItem) {
      if (selectedItem.value === 'can_t_go') {
        size = 'small'
      } else if (
        mixrAttendingType === 'both' &&
        (selectedItem.value === 'virtual' || selectedItem.value === 'in_person')
      ) {
        size = 'medium'
      }
    }
    return size
  }

  const closeJoinGroupPopup = () => {
    setShowJoinGroupPopup(false)
    setJoinGroupForMixrId(0)
  }
  const closePendingApprovalPopup = () => {
    setShowPendingApprovalPopup(false)
  }

  const closeAutoJoinGroupPopup = () => {
    setShowAutoJoinGroupWarning(false)
  }

  useEffect(() => {
    //call this useEffect on load, not when rsvp dropdown change
    if (!isRSVPChanged) {
      const items = getRsvpDropdownOptions()
      if (items && items.length > 0) {
        const selected = items.find((i) => {
          if (recurrenceMixrAttending === 'all') {
            if (selectedUserAttending === 'in_person') {
              return i.value === 'in_person'
            }
            if (selectedUserAttending === 'virtual') {
              return i.value === 'virtual'
            }
          }
          return i.value === selectedUserAttending
        })
        const selectedItemWithIcon = updateSelectedItemWithIcon(selected)
        setSelectedItem(selectedItemWithIcon ? selectedItemWithIcon : { value: null, label: t('mixrHome.feeds.rsvp') })
      }
    }
  }, [isRSVPChanged, selectedUserAttending])

  const updateSelectedItemWithIcon = (selected) => {
    if (selected) {
      if (selected.value === 'virtual') {
        let newLabel = (
          <span className={styles.selectedRSVP}>
            {t('mixrHome.feeds.going')}
            <Icon name='virtualmixr-icon' styleModifier={styles.virtualIcon} />
          </span>
        )
        selected.label = newLabel
      } else if (selected.value === 'in_person') {
        let newLabel = (
          <span className={styles.selectedRSVP}>
            {t('mixrHome.feeds.going')}
            <Icon name='inpersonmixr-icon' styleModifier={styles.inpersonIcon} />
          </span>
        )
        selected.label = newLabel
      }
    }
    return selected
  }

  const handleRSVPChange = (option) => {
    // if there is no change in selection. e.g. if "Going inperson" is already selected, if user selects "Going inperson" again,
    //then this logic won't be triggered
    const value = option.value.split('__')[0]
    if (option.value !== selectedUserAttending) {
      let updatedSelectedItem = null

      if (option.recur === 'all' && value !== 'both') {
        //if selected option is "going to all"  for either in_person or virtual
        const item = getRsvpDropdownOptions().find((x) => x.value === value)
        updatedSelectedItem = { ...item, recur: option.recur }
      } else if (option.recur === 'none' || value === 'can_t_go') {
        //if selected option 'non-recurring' or 'can't go'
        updatedSelectedItem = option
      }
      //update the selected item with respective inperson/virtual icon
      if (updatedSelectedItem) {
        const selectedItemWithIcon = updateSelectedItemWithIcon(updatedSelectedItem)
        setSelectedItem(selectedItemWithIcon)
      }
      setIsRSVPChanged(true)
      if (value === 'both') {
        setIsRecAllModalOpen(true)
      } else {
        dispatch(rsvpActions.updateAttendance(mixrId, value, option.recur))
      }
    }
  }

  const handleAttendanceAll = (type) => {
    //recur will 'all' as this function is called from modal popup for "going to all"
    const recur = 'all'
    //get item from all rsvp options that match 'in_person' / 'virtual'
    const item = getRsvpDropdownOptions().find((x) => x.value === type)
    //update the selected item with respective inperson/virtual icon
    const selectedItemWithIcon = updateSelectedItemWithIcon({ ...item, recur })
    setSelectedItem(selectedItemWithIcon)
    dispatch(rsvpActions.updateAttendance(mixrId, type, recur))
    setIsRecAllModalOpen(false)
  }

  const handleParticipate = () => {
    setIsRSVPChanged(true)
    dispatch(rsvpActions.updateAttendance(mixrId, 'in_person'))
  }

  const refuseInvitation = () => {
    dispatch(rsvpActions.rejectInvitation(mixrId))
  }

  return (
    <div className={styles.rsvpContainer}>
      {groupRole !== 'none' && selectedUserAttending !== 'pending_participant' ? (
        <Dropdown1
          isDisabled={isStatic}
          value={selectedItem && !selectedItem.value ? '' : selectedItem}
          options={getRsvpDropdownOptions()}
          className={`${styles.rsvpDropdown} ${styles[textSize()]} ${
            selectedItem && !selectedItem.value ? styles.green : ''
          } ${className} `}
          classNamePrefix='rsvp'
          onChange={!isStatic && handleRSVPChange}
          isSearchable={false}
          placeholder={t('mixrHome.feeds.rsvp')}
          menuPortalTarget={menuPortalTarget}
          removeSeparator={false}
          aria-label={t('formlabel.rsvp')}
          //menuShouldBlockScroll={true} //this change moves header content a bit
        />
      ) : selectedUserAttending === 'pending_participant' ? (
        <Button
          style='orange'
          customStyle={`${styles.pendingRequestButton} ${styles.longStatus}`}
          text={t('mixrHome.pendingRequest')}
        />
      ) : withoutGroupAproval === 1 ? (
        <Button
          customStyle={`${styles.participantButton} ${isInvite ? styles.longStatus : ''}`}
          text={isInvite ? t('global.acceptInvitation') : t('mixrHome.participate')}
          handleClick={() => {
            if (!isStatic) {
              setShowAutoJoinGroupWarning(true)
              setJoinGroupForMixrId(mixrId)
            }
          }}
        />
      ) : withoutGroupAproval === 0 ? (
        <Button
          customStyle={`${styles.participantButton} ${isInvite ? styles.longStatus : ''}`}
          text={isInvite ? t('global.acceptInvitation') : t('mixrHome.requestToParticipate')}
          handleClick={() => {
            if (!isStatic) {
              setShowJoinGroupPopup(true)
              setJoinGroupForMixrId(mixrId)
            }
          }}
        />
      ) : null}

      {showJoinGroupPopup && joinGroupForMixrId === mixrId && (
        <ConfirmModal
          isOpen={showJoinGroupPopup}
          title={t('mixrHome.joinGroupTitle')}
          titleCSS={styles.modalTitle}
          primaryButtonText={t('mixrHome.btnRequestToJoinGroup')}
          secondatyButtonText={t('global.cancel')}
          handlePrimaryButton={handleParticipate}
          handleSecondaryButton={closeJoinGroupPopup}
          closeModal={closeJoinGroupPopup}
        />
      )}
      {showAutoJoinGroupWarning && joinGroupForMixrId === mixrId && (
        <ConfirmModal
          isOpen={showAutoJoinGroupWarning}
          primaryButtonText={isInvite && t('global.accept')}
          secondatyButtonText={isInvite && t('global.decline')}
          title={
            isInvite
              ? t('mixrHome.autoJoinGroupByInviteTitle', { groupName })
              : t('mixrHome.autoJoinGroupTitle', { groupName })
          }
          hasTitleHTML={true}
          handlePrimaryButton={handleParticipate}
          handleSecondaryButton={isInvite ? refuseInvitation : closeAutoJoinGroupPopup}
          closeModal={closeAutoJoinGroupPopup}
          loading={rsvpLoading}
        />
      )}
      {isRecAllModalOpen && (
        <ConfirmModal
          isOpen={isRecAllModalOpen}
          primaryButtonText={t('myhome.mymixrs.attendingType.in_person')}
          secondatyButtonText={t('myhome.mymixrs.attendingType.virtual')}
          title={t('myhome.mymixrs.attendingType.ask_choice')}
          handlePrimaryButton={() => handleAttendanceAll('in_person')}
          handleSecondaryButton={() => handleAttendanceAll('virtual')}
          closeModal={() => setIsRecAllModalOpen(false)}
        />
      )}
      {showPendingApprovalPopup && joinGroupForMixrId === mixrId && (
        <Modal isOpen={showPendingApprovalPopup} handleClose={closePendingApprovalPopup}>
          <PendingJoinGroupApproval closeModal={closePendingApprovalPopup} />
        </Modal>
      )}
    </div>
  )
}
